export const FETCH_BY_ACTIVE_FOLDER = 'documents/FETCH_BY_ACTIVE_FOLDER';
export const FETCH_BY_ACTIVE_FOLDER_SUCCESS = 'documents/FETCH_BY_ACTIVE_FOLDER_SUCCESS';
export const FETCH_BY_ACTIVE_FOLDER_ERROR = 'documents/FETCH_BY_ACTIVE_FOLDER_ERROR';

export const FETCH_RECURSIVE_BY_FOLDER_PATH = 'documents/FETCH_RECURSIVE_BY_FOLDER_PATH';
export const FETCH_RECURSIVE_BY_FOLDER_PATH_SUCCESS = 'documents/FETCH_RECURSIVE_BY_FOLDER_PATH_SUCCESS';
export const FETCH_RECURSIVE_BY_FOLDER_PATH_ERROR = 'documents/FETCH_RECURSIVE_BY_FOLDER_PATH_ERROR';

export const FETCH = 'documents/FETCH';
export const FETCH_SUCCESS = 'documents/FETCH_SUCCESS';
export const FETCH_ERROR = 'documents/FETCH_ERROR';

export const UPLOAD = 'documents/UPLOAD';
export const UPLOAD_SUCCESS = 'documents/UPLOAD_SUCCESS';
export const UPLOAD_ERROR = 'documents/ERROR';

export const DOWNLOAD = 'documents/DOWNLOAD';
export const DOWNLOAD_SUCCESS = 'documents/DOWNLOAD_SUCCESS';
export const DOWNLOAD_ERROR = 'documents/DOWNLOAD_ERROR';

export const DOWNLOAD_MULTIPLE = 'documents/DOWNLOAD_MULTIPLE';
export const DOWNLOAD_MULTIPLE_SUCCESS = 'documents/DOWNLOAD_MULTIPLE_SUCCESS';
export const DOWNLOAD_MULTIPLE_ERROR = 'documents/DOWNLOAD_MULTIPLE_ERROR';

export const CLONE = 'documents/CLONE';
export const CLONE_SUCCESS = 'documents/CLONE_SUCCESS';

export const UPDATE = 'documents/UPDATE';
export const UPDATE_SUCCESS = 'documents/UPDATE_SUCCESS';
export const UPDATE_PASSWORD_MISMATCH = 'documents/UPDATE_PASSWORD_MISMATCH';
export const UPDATE_ERROR = 'documents/UPDATE_ERROR';

export const DELETE = 'documents/DELETE';
export const DELETE_SUCCESS = 'documents/DELETE_SUCCESS';
export const DELETE_ERROR = 'documents/DELETE_ERROR';

export const SET_ACTIVE_DOCUMENT_ID = 'documents/SET_ACTIVE_DOCUMENT_ID';
export const SET_UPLOAD_PERCENTAGE = 'documents/SET_UPLOAD_PERCENTAGE';

export const SHARE = 'documents/SHARE';
export const SHARE_SUCCESS = 'documents/SHARE_SUCCESS';
export const SHARE_ERROR = 'documents/SHARE_ERROR';

export const NAVIGATE_TO_DOCUMENT = 'documents/NAVIGATE_TO_DOCUMENT';
